<template>
  <modal v-model="isVisible" size="sm" data-dismiss="modal">
    <form @submit.prevent="onSubmit">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <h4 class="c-modalCard__title">Alterar conta</h4>
          <a role="button" class="c-modalCard__close" v-on:click="close">
            <i class="i-remove"></i>
          </a>
        </header>
        <div class="c-modalCard__body">
          <div class="l-row">
            <form-group :columns="12" label="Conta" v-if="merchants">
              <multiselect
                v-model="selectMerchant"
                :options="merchants"
                selectLabel=""
                selectedLabel=""
                placeholder="Selecione"
                label="name"
                track-by="identifier"
              />
            </form-group>
          </div>
        </div>
        <footer class="c-modalCard__footer">
          <button type="button" class="btn btn--default" @click="close">Fechar</button>
          <button type="submit" class="btn btn--primary">Alterar</button>
        </footer>
      </div>
    </form>
  </modal>
</template>

<script>
  import { mapFields } from 'vuex-map-fields'
  import FormGroup from '@/components/template/FormGroup'
  import { mapActions } from 'vuex'
  import notifier from '@/notifier'
  import { cloneDeep, isEmpty } from 'lodash'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      isVisible: false,
      selectMerchant: null,
      modal: null,
      merchant: null,
      merchants: null
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      if (!isEmpty(this.user)) {
        this.sortMerchants()
      }

      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      ...mapActions('user', [
        'changeMerchant'
      ]),
      sortMerchants () {
        this.merchants = (cloneDeep(this.user.merchants))
          .sort((a, b) => {
            if (a.identifier < b.identifier) {
              return -1
            } else if (a.identifier > b.identifier) {
              return 1
            }
            return 0
          })
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      onSubmit () {
        if (this.merchant !== null) {
          this.changeMerchant(this.merchant)
        } else {
          notifier.error('Selecione uma conta', 'Erro')
        }
      }
    },
    computed: {
      ...mapFields({
        user: 'user.user'
      })
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      },
      selectMerchant (value) {
        this.merchant = value.identifier
      },
      user () {
        this.sortMerchants()
      }
    },
    components: {
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .c-modalCard__body
    overflow: visible

</style>



// WEBPACK FOOTER //
// ModalAccounts.vue?ecdba604